const Recommendations = ({
  maxProductsPerPage,
  type,
  productId,
  className,
  allowRefresh = false,
  autoLoad = true,
  skuId,
  placement,
  isJoyfullyBold
}) => (
  <jl-recommendations-panel
    skuId={skuId}
    autoLoad={autoLoad}
    productId={productId}
    maxProductsPerPage={maxProductsPerPage}
    class={className}
    placement={placement}
    allowRefresh={allowRefresh}
    type={type}
    isJoyfullyBold={isJoyfullyBold}
  />
);

export default Recommendations;
